// redirect-to-custom-checkout.js
// Substitui o antigo cart-product-swap-advanced.js.
//
// A troca de produto (product swap) agora roda 100% no BACKEND do
// checkout próprio (PHP) — não faz mais sentido duplicar essa lógica
// aqui no navegador. Este script faz só uma coisa: intercepta o clique
// no botão de "Finalizar Compra" do carrinho da Shopify, lê os itens
// (sem alterar nada no carrinho) e redireciona o cliente pro checkout
// próprio, hospedado fora da Shopify.
//
// Formato da URL gerada:
//   {CHECKOUT_BASE_URL}?items=VARIANT_ID:QTD,VARIANT_ID:QTD,...
//
// CHECKOUT_BASE_URL vem de window.customCheckoutBaseUrl, definido no
// layout/theme.liquid (e layout/blank.liquid) — só precisa editar lá
// quando o domínio do checkout mudar (ex: ao comprar o domínio final).

(function () {
  "use strict";

  function logMessage(message, data) {
    console.log("Redirect to Custom Checkout:", message, data !== undefined ? data : "");
  }

  function showLoadingIndicator(button) {
    if (!button) return;
    button.disabled = true;
    if (button.tagName === "INPUT") {
      button.value = "Procesando...";
    } else {
      button.textContent = "Procesando...";
    }
  }

  function hideLoadingIndicator(button, originalText) {
    if (!button) return;
    button.disabled = false;
    if (button.tagName === "INPUT") {
      button.value = originalText;
    } else {
      button.innerHTML = originalText;
    }
  }

  async function handleCheckoutClick(event, checkoutButton, originalButtonText) {
    event.preventDefault();
    logMessage("Botão de checkout clicado.");
    showLoadingIndicator(checkoutButton);

    try {
      var baseUrl = window.customCheckoutBaseUrl;
      if (!baseUrl) {
        throw new Error("window.customCheckoutBaseUrl não está definido no tema.");
      }

      var cartResponse = await fetch("/cart.js");
      if (!cartResponse.ok) throw new Error("Falha ao obter carrinho: " + cartResponse.status);
      var cartData = await cartResponse.json();
      logMessage("Carrinho atual:", cartData);

      if (!cartData.items || cartData.items.length === 0) {
        logMessage("Carrinho vazio, nada a fazer.");
        hideLoadingIndicator(checkoutButton, originalButtonText);
        return;
      }

      // Monta "variantId:qty,variantId:qty" — o backend do checkout é
      // quem decide preço, aplica troca de produto (se houver
      // mapeamento) e valida tudo. Nunca confiamos em preço vindo daqui.
      var itemsParam = cartData.items
        .map(function (item) {
          return item.variant_id + ":" + item.quantity;
        })
        .join(",");

      var destination = baseUrl + "?items=" + encodeURIComponent(itemsParam);
      logMessage("Redirecionando para o checkout próprio:", destination);
      window.location.href = destination;

    } catch (error) {
      logMessage("Erro ao redirecionar para o checkout:", error);
      alert("Ocurrió un error al iniciar el pago. Por favor, inténtalo de nuevo o contacta soporte.\nDetalle: " + error.message);
      hideLoadingIndicator(checkoutButton, originalButtonText);
    }
  }

  function initCheckoutRedirect() {
    // Mesmo seletor do script antigo: no tema Xtra, os botões REAIS de
    // checkout têm classe começando com "overlay-"; existe também um
    // botão de cupom que por acaso também usa name="checkout".
    var checkoutButtons = document.querySelectorAll(
      "button[class^=\"overlay-\"][name=\"checkout\"], input[class^=\"overlay-\"][name=\"checkout\"]"
    );
    if (!checkoutButtons.length) {
      checkoutButtons = document.querySelectorAll("button[name=\"checkout\"], input[name=\"checkout\"]");
    }
    if (!checkoutButtons.length) {
      return;
    }

    checkoutButtons.forEach(function (checkoutButton) {
      if (checkoutButton.dataset.customCheckoutBound === "1") return;
      checkoutButton.dataset.customCheckoutBound = "1";

      var originalButtonText = checkoutButton.tagName === "INPUT" ? checkoutButton.value : checkoutButton.innerHTML;

      checkoutButton.addEventListener("click", function (event) {
        handleCheckoutClick(event, checkoutButton, originalButtonText);
      });

      logMessage("Botão de checkout conectado:", checkoutButton.id || checkoutButton.className);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initCheckoutRedirect);
  } else {
    initCheckoutRedirect();
  }

  // O drawer do carrinho é injetado/atualizado dinamicamente neste tema
  // (Section Rendering API) — reconecta os botões sempre que o carrinho
  // for atualizado.
  document.addEventListener("cart:refresh", initCheckoutRedirect);
  document.addEventListener("cart:update", initCheckoutRedirect);

})();
